module.exports = __webpack_public_path__ + "img/motorcheck.9b8ceb2a.svg";